<template>
  <VUEModal v-if="PopupImpostazioniAssi" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_X',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupAssi()">
    <template v-slot:Body>      
      <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjPopupImpostazioniAssi.Axis.Min">
          <p style="width: 15%; margin: 0px; margin-left: 10px; font-weight: bold">{{ '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIGRAMMO',this.LinguaUtente) + ']' }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjPopupImpostazioniAssi.Axis.Max">
          <p style="width: 15%; margin: 0px; margin-left: 10px; font-weight: bold">{{ '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIGRAMMO',this.LinguaUtente) + ']' }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="width: 40%; margin: 0px; font-weight: bold">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="ObjPopupImpostazioniAssi.Axis.Udm">
          <p style="width: 15%; margin: 0px; margin-left: 10px; font-weight: bold">{{ '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIGRAMMO',this.LinguaUtente) + ']' }}</p>
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupAssi()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupAssi()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>
  <VUEModal v-if="PopupLegenda" :Titolo="this.GetTraduzioneLabel('Generic','TKN_LEGENDA',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="ChiudiPopupLegenda()">
    <template v-slot:Body>      
      <div v-for="Voce in ArrayLegenda" :key="Voce" style="display: flex; flex-flow: row wrap; margin-left: 10px; margin-right: 10px">
        <span style="width: 20px; height: 20px; margin:0px; margin-right: 10px" :style="{'background-color' : Voce.Colore}"></span>
        <label>{{ 'Data: ' + Voce.Data + ' - Modulo nr. ' + Voce.Modulo }}</label>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="ChiudiPopupLegenda()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CHIUDI',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>
  <VUEModal v-if="PopupSintetici" :Titolo="this.GetTraduzioneLabel('Generic','TKN_DATI_SINTETICI',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="ChiudiPopupSintetici()">
    <template v-slot:Body>      
      <div v-if="EventiSovrapposti">
        <div v-for="SingleEvento in Evento" :key="SingleEvento" style="display: flex; flex-flow: column wrap; margin-bottom: 5px; padding-bottom: 5px; border-bottom: solid;">
          <div style="display: flex; flex-flow: row wrap">
            <label>{{ this.GetTraduzioneLabel('Generic','TKN_MOD_NR',this.LinguaUtente) + ' ' + SingleEvento.Modulo }}</label>
          </div>
          <div style="display: flex; flex-flow: row wrap">
            <label>{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_N_CAMP',this.LinguaUtente) + ': ' + SingleEvento.Campioni.length + ' - ' + this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_PER_CAMP',this.LinguaUtente) + ': ' + SingleEvento.PeriodoCampionamento + ' - ' + this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_CAMP_P_ROLL',this.LinguaUtente) + ': ' + SingleEvento.NrCampioniPreRoll }}</label>
          </div>
          <div style="display: flex; flex-flow: row wrap">
            <label>{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_MIN_ACC_X',this.LinguaUtente) + ': ' + SingleEvento.MinAccX + ' - ' + this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_MAX_ACC_X',this.LinguaUtente) + ': ' + SingleEvento.MaxAccX }}</label>
          </div>
          <div style="display: flex; flex-flow: row wrap">
            <label>{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_MIN_ACC_Y',this.LinguaUtente) + ': ' + SingleEvento.MinAccY + ' - ' + this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_MAX_ACC_Y',this.LinguaUtente) + ': ' + SingleEvento.MaxAccY }}</label>
          </div>
          <div style="display: flex; flex-flow: row wrap">
            <label>{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_MIN_ACC_Z',this.LinguaUtente) + ': ' + SingleEvento.MinAccZ + ' - ' + this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_MAX_ACC_Z',this.LinguaUtente) + ': ' + SingleEvento.MaxAccZ }}</label>          
          </div>
        </div>
      </div>
      <div style="display: flex; flex-flow: column wrap;" v-else>
        <div style="display: flex; flex-flow: row wrap">
          <label>{{ this.GetTraduzioneLabel('Generic','TKN_MOD_NR',this.LinguaUtente) + ' ' + Evento.Modulo }}</label>
        </div>
        <div style="display: flex; flex-flow: row wrap">
          <label>{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_N_CAMP',this.LinguaUtente) + ': ' + Evento.Campioni.length + ' - ' + this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_PER_CAMP',this.LinguaUtente) + ': ' + Evento.PeriodoCampionamento + ' - ' + this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_CAMP_P_ROLL',this.LinguaUtente) + ': ' + Evento.NrCampioniPreRoll }}</label>
        </div>
        <div style="display: flex; flex-flow: row wrap">
          <label>{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_MAX_ACC_X',this.LinguaUtente) + ': ' + Evento.MinAccX + ' - ' + this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_MIN_ACC_X',this.LinguaUtente) + ': ' + Evento.MaxAccX }}</label>
        </div>
        <div style="display: flex; flex-flow: row wrap">
          <label>{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_MAX_ACC_Y',this.LinguaUtente) + ': ' + Evento.MinAccY + ' - ' + this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_MIN_ACC_Y',this.LinguaUtente) + ': ' + Evento.MaxAccY }}</label>
        </div>
        <div style="display: flex; flex-flow: row wrap">
          <label>{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_MAX_ACC_Z',this.LinguaUtente) + ': ' + Evento.MinAccZ + ' - ' + this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_MIN_ACC_Z',this.LinguaUtente) + ': ' + Evento.MaxAccZ }}</label>          
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="ChiudiPopupSintetici()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CHIUDI',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>
  <div>
    <div class="ZMSeparatoreScheda" style="margin: 0px; width: 100%;" :style="{'background-color' : ColoriPantone.Marrone }">       
      <text style="font-weight: bold;">{{TitoloFrame}}</text>
    </div>
    <div style="display: flex; flex-flow: row wrap; width: 100%">
      <div style="width:83%; display: flex; flex-flow: column nowrap;" ref="DivCanvas">
        <VUEComponenteGraficoAccSupSoglie :WidthGrafico="GrandezzaCanvas.Width" 
                                          :HeightGrafico="GrandezzaCanvas.Height"
                                          :Dati="ObjGraficoX"
                                          :Repaint="Repaint"
                                          :RepaintDeep="RepaintDeep"
                                          :Tipo="'X'"
                                          :EventiSovrapposti="EventiSovrapposti"
                                          :MinData="MinData"
                                          :MinDataMs="MinDataMs"/>
        
        <VUEComponenteGraficoAccSupSoglie :WidthGrafico="GrandezzaCanvas.Width" 
                                          :HeightGrafico="GrandezzaCanvas.Height"
                                          :Dati="ObjGraficoY"
                                          :Repaint="Repaint"
                                          :RepaintDeep="RepaintDeep"
                                          :Tipo="'Y'"
                                          :EventiSovrapposti="EventiSovrapposti"
                                          :MinData="MinData"
                                          :MinDataMs="MinDataMs"/>
        
        <VUEComponenteGraficoAccSupSoglie :WidthGrafico="GrandezzaCanvas.Width" 
                                          :HeightGrafico="GrandezzaCanvas.Height"
                                          :Dati="ObjGraficoZ"
                                          :Repaint="Repaint"
                                          :RepaintDeep="RepaintDeep"
                                          :Tipo="'Z'"
                                          :EventiSovrapposti="EventiSovrapposti"
                                          :MinData="MinData"
                                          :MinDataMs="MinDataMs"/>
      </div>
        
      <div style="width:17%; display: flex;" ref="DivButtons">
        <div style="margin-top:5px">
          <div style="width:calc(100% - 16px); margin-left: 8px; margin-right: 8px">
            <button type="button" class="btn btn-info" @click="AdattaAll()" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_ADATTA',this.LinguaUtente) }}</button>

            <button type="button" class="btn btn-info" @click="ApriPopupImpostazioniAssi(TipiAssi.X)" style="width:100%; margin-top: 4px">{{ this.GetTraduzioneLabel('Generic','TKN_ASSE_X',this.LinguaUtente) }}</button>

            <button type="button" class="btn btn-info" @click="ApriPopupImpostazioniAssi(TipiAssi.Y)" style="width:100%; margin-top: 4px">{{ this.GetTraduzioneLabel('Generic','TKN_ASSE_Y',this.LinguaUtente) }}</button>

            <button type="button" class="btn btn-info" @click="ApriPopupImpostazioniAssi(TipiAssi.Z)" style="width:100%; margin-top: 4px">{{ this.GetTraduzioneLabel('Generic','TKN_ASSE_Z',this.LinguaUtente) }}</button>

            <button type="button" class="btn btn-info" @click="ApriPopupImpostazioniAssi(TipiAssi.Tutte)" style="width:100%; margin-top: 4px">{{ this.GetTraduzioneLabel('Generic','TKN_ASSI',this.LinguaUtente) }}</button>

            <button type="button" class="btn btn-info" @click="EsportaComePDF()" style="width:100%; margin-top: 4px">{{ this.GetTraduzioneLabel('Generic','TKN_EXP_PDF',this.LinguaUtente) }}</button>

            <button type="button" class="btn btn-info" @click="EsportaExcel()" style="width:100%; margin-top: 4px">{{ this.GetTraduzioneLabel('Generic','TKN_EXP_DATI',this.LinguaUtente) }}</button>

            <button type="button" class="btn btn-info" @click="ApriPopupDatiSintetici()" style="width:100%; margin-top: 4px">{{ this.GetTraduzioneLabel('Generic','TKN_DATI_SINTETICI',this.LinguaUtente) }}</button>

            <button v-if="EventiSovrapposti" type="button" class="btn btn-info" style="width:100%; margin-top: 4px" @click="ApriPopupLegenda()">{{ this.GetTraduzioneLabel('Generic','TKN_LEGENDA',this.LinguaUtente) }}</button>
            
            <div style="clear:both;height:10px"></div>
          
          </div>   
          <div style="float:left;width:4%;">&nbsp;</div>
        </div>
      </div>
    </div>
  </div>
  <div style="clear:both"></div>

</template>

<script>
import VUEComponenteGraficoAccSupSoglie from './VUEComponenteGraficoAccSupSoglie.vue'
import VUEModal from '@/utils/VUEModal.vue'
import { COLORI_DEFAULT_GRAFICI, COLORI_PANTONE, TIPI_UDM_X, SystemInformation } from '@/SystemInformation'
import { TZGenericFunct } from '@/utils/ZGenericFunct'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import { TZMathFunct } from '@/utils/ZMathFunct'
import { TZDateFunct } from '@/utils/ZDateFunct'
import XLSX from 'xlsx-js-style/dist/xlsx.min.js'

const TIPI_ASSI = {
                    Tutte : -1,
                    X     : 0,
                    Y     : 1,
                    Z     : 2
                  }

const SOGLIA_UDM_MS = 10 * 60 * 1000
const SOGLIA_UDM_MINUTI = 6 * 3600 * 1000

export default 
{
  mixins: [ MixInsGestioneTraduzioni ],
  data()
  {
   return {
            ColoriPantone            : COLORI_PANTONE,
            GrandezzaCanvas          : {
                                         Width  : 0,
                                         Height : 0
                                       },
            ObjGraficoX              : {},
            ObjGraficoY              : {},
            ObjGraficoZ              : {},
            TipiUdmX                 : TIPI_UDM_X,
            ObjGrafico               : {},
            Repaint                  : 0,
            RepaintDeep              : 0,
            PopupImpostazioniAssi    : false,
            PopupLegenda             : false,
            PopupSintetici           : false,
            ArrayLegenda             : [],
            ObjPopupImpostazioniAssi : {},
            TipiAssi                 : TIPI_ASSI,
            PrimoCampione            : {X: 0, Y: 0, Z: 0},
            LinguaUtente             : SystemInformation.UserInformation.Lingua,
            TitoloFrame              : ''
          }
  },

  props : ['DataPartenza', 'MinData', 'MinDataMs', 'UltimaData', 'Evento', 'Stacking', 'Relativo', 'GraficiChange', 'GraficiAdatta', 'EventiSovrapposti', 'ParametriPDF', 'GetDatiPDF', 'GraphProps', 'GraficiChangeAllSupSoglie', 'ListaRighelli'],
  emits : ['EsportaPDFGrafico'],
  components:
  {
    VUEComponenteGraficoAccSupSoglie,
    VUEModal,
  },

  methods :
  {
    ApriPopupDatiSintetici()
    {
      this.PopupSintetici = true
    },

    ChiudiPopupSintetici()
    {
      this.PopupSintetici = false
    },

    ApriPopupLegenda()
    {
      this.ArrayLegenda = []
      for (let i = 0; i < this.Evento.length; i++)
      {
        let ObjLegenda = {}
        let IndexColore = i
        while (IndexColore >= COLORI_DEFAULT_GRAFICI.length)
        {
          IndexColore = IndexColore - COLORI_DEFAULT_GRAFICI.length
        }
        ObjLegenda.Colore = COLORI_DEFAULT_GRAFICI[IndexColore]
        ObjLegenda.Modulo = this.Evento[i].Modulo
        ObjLegenda.Data = this.Evento[i].DataEffettiva
        this.ArrayLegenda.push(ObjLegenda)
      }
      this.PopupLegenda = true
    },

    ChiudiPopupLegenda()
    {
      this.PopupLegenda = false
    },

    CalcolaGrandezzaDivCanvas()
    {
      this.Repaint++
      this.GrandezzaCanvas.Width  = this.$refs.DivCanvas.clientWidth 
      this.GrandezzaCanvas.Height = 150 // this.$refs.DivButtons.clientHeight
    },

    ChangeRelativo()
    {
      let StartAsseY = {}
      StartAsseY.Min = 0
      StartAsseY.Max = 10
      StartAsseY.Udm = 1
      this.PrimoCampione.X = 0
      this.PrimoCampione.Y = 0
      this.PrimoCampione.Z = 0
      if (!this.EventiSovrapposti)
      {
        this.ObjGraficoX.Generale.Campioni = []
        this.ObjGraficoY.Generale.Campioni = []
        this.ObjGraficoZ.Generale.Campioni = []
        for (let i = 0; i < this.Evento.Campioni.length; i++)
        {
          let SingoloCampione = this.Evento.Campioni[i] 
          if (i == 0 && this.Relativo)
          {
            this.PrimoCampione.X = SingoloCampione.X
            this.PrimoCampione.Y = SingoloCampione.Y
            this.PrimoCampione.Z = SingoloCampione.Z
          }
          this.ObjGraficoX.Generale.Campioni.push((SingoloCampione.X - this.PrimoCampione.X))
          this.ObjGraficoY.Generale.Campioni.push((SingoloCampione.Y - this.PrimoCampione.Y))
          this.ObjGraficoZ.Generale.Campioni.push((SingoloCampione.Z - this.PrimoCampione.Z))

          let MinY = Math.min(SingoloCampione.X - this.PrimoCampione.X,
                              SingoloCampione.Y - this.PrimoCampione.Y,
                              SingoloCampione.Z - this.PrimoCampione.Z)

          let MaxY = Math.max(SingoloCampione.X - this.PrimoCampione.X,
                              SingoloCampione.Y - this.PrimoCampione.Y,
                              SingoloCampione.Z - this.PrimoCampione.Z)

          if (StartAsseY.Min > (MinY))
            StartAsseY.Min = MinY
          if (StartAsseY.Max < (MaxY))
            StartAsseY.Max = MaxY
        }
      }
      else
      {
        for (let i = 0; i < this.Evento.length; i++)
        {
          let SingleEvento = this.Evento[i]

          this.ObjGraficoX.Eventi[i] = {Campioni : [], PeriodoCampionamento : SingleEvento.PeriodoCampionamento, DataEffettiva : SingleEvento.DataEffettiva, Millisecondi : SingleEvento.Millisecondi}
          this.ObjGraficoY.Eventi[i] = {Campioni : [], PeriodoCampionamento : SingleEvento.PeriodoCampionamento, DataEffettiva : SingleEvento.DataEffettiva, Millisecondi : SingleEvento.Millisecondi}
          this.ObjGraficoZ.Eventi[i] = {Campioni : [], PeriodoCampionamento : SingleEvento.PeriodoCampionamento, DataEffettiva : SingleEvento.DataEffettiva, Millisecondi : SingleEvento.Millisecondi}         

          for (let j = 0; j < SingleEvento.Campioni.length; j++)
          {
            let SingoloCampione = SingleEvento.Campioni[j]
            if (j == 0 && this.Relativo)
            {
              this.PrimoCampione.X = SingoloCampione.X
              this.PrimoCampione.Y = SingoloCampione.Y
              this.PrimoCampione.Z = SingoloCampione.Z
            }
            this.ObjGraficoX.Eventi[i].Campioni.push((SingoloCampione.X - this.PrimoCampione.X))
            this.ObjGraficoY.Eventi[i].Campioni.push((SingoloCampione.Y - this.PrimoCampione.Y))
            this.ObjGraficoZ.Eventi[i].Campioni.push((SingoloCampione.Z - this.PrimoCampione.Z))

            let MinY = Math.min(SingoloCampione.X - this.PrimoCampione.X,
                                SingoloCampione.Y - this.PrimoCampione.Y,
                                SingoloCampione.Z - this.PrimoCampione.Z)

            let MaxY = Math.max(SingoloCampione.X - this.PrimoCampione.X,
                                SingoloCampione.Y - this.PrimoCampione.Y,
                                SingoloCampione.Z - this.PrimoCampione.Z)

            if (StartAsseY.Min > (MinY))
              StartAsseY.Min = MinY
            if (StartAsseY.Max < (MaxY))
              StartAsseY.Max = MaxY
          }
        }
      }
      StartAsseY.Udm = TZMathFunct.GetMultiplo((StartAsseY.Max - StartAsseY.Min) / 5, 5, 'PiuVicino')
      if (StartAsseY.Udm == 0)
        StartAsseY.Udm = 1    

      this.ObjGraficoX.AxisY.Min = StartAsseY.Min
      this.ObjGraficoX.AxisY.Max = StartAsseY.Max
      this.ObjGraficoX.AxisY.Udm = StartAsseY.Udm

      this.ObjGraficoY.AxisY.Min = StartAsseY.Min
      this.ObjGraficoY.AxisY.Max = StartAsseY.Max
      this.ObjGraficoY.AxisY.Udm = StartAsseY.Udm

      this.ObjGraficoZ.AxisY.Min = StartAsseY.Min
      this.ObjGraficoZ.AxisY.Max = StartAsseY.Max
      this.ObjGraficoZ.AxisY.Udm = StartAsseY.Udm
      
      if (!this.Relativo)
        this.AdattaAll()

      this.RepaintDeep++
    },

    AdattaAll()
    {
      this.ObjGraficoX.AxisY.Min = 99999
      this.ObjGraficoX.AxisY.Max = -99999
      this.ObjGraficoY.AxisY.Min = 99999
      this.ObjGraficoY.AxisY.Max = -99999
      this.ObjGraficoZ.AxisY.Min = 99999
      this.ObjGraficoZ.AxisY.Max = -99999

      this.PrimoCampione.X = 0
      this.PrimoCampione.Y = 0
      this.PrimoCampione.Z = 0

      if (!this.EventiSovrapposti)
      {
        for (let i = 0; i < this.Evento.Campioni.length; i++)
        {
          let SingoloCampione = this.Evento.Campioni[i] 
          if (i == 0 && this.Relativo)
          {
            this.PrimoCampione.X = SingoloCampione.X
            this.PrimoCampione.Y = SingoloCampione.Y
            this.PrimoCampione.Z = SingoloCampione.Z
          }
          if (this.ObjGraficoX.AxisY.Min > (SingoloCampione.X - this.PrimoCampione.X))
            this.ObjGraficoX.AxisY.Min = (SingoloCampione.X - this.PrimoCampione.X)
          if (this.ObjGraficoX.AxisY.Max < (SingoloCampione.X - this.PrimoCampione.X))
            this.ObjGraficoX.AxisY.Max = (SingoloCampione.X - this.PrimoCampione.X)
          if (this.ObjGraficoY.AxisY.Min > (SingoloCampione.Y - this.PrimoCampione.Y)) 
            this.ObjGraficoY.AxisY.Min = (SingoloCampione.Y - this.PrimoCampione.Y)
          if (this.ObjGraficoY.AxisY.Max < (SingoloCampione.Y - this.PrimoCampione.Y))
            this.ObjGraficoY.AxisY.Max = (SingoloCampione.Y - this.PrimoCampione.Y)
          if (this.ObjGraficoZ.AxisY.Min > (SingoloCampione.Z - this.PrimoCampione.Z))
            this.ObjGraficoZ.AxisY.Min = (SingoloCampione.Z - this.PrimoCampione.Z)
          if (this.ObjGraficoZ.AxisY.Max < (SingoloCampione.Z - this.PrimoCampione.Z))
            this.ObjGraficoZ.AxisY.Max = (SingoloCampione.Z - this.PrimoCampione.Z)
        }
      }
      else
      {
        this.Evento.forEach((element) =>
        {
          for (let i = 0; i < element.Campioni.length; i++)
          {
            let SingoloCampione = element.Campioni[i] 
            if (i == 0 && this.Relativo)
            {
              this.PrimoCampione.X = SingoloCampione.X
              this.PrimoCampione.Y = SingoloCampione.Y
              this.PrimoCampione.Z = SingoloCampione.Z
            }
            if (this.ObjGraficoX.AxisY.Min > (SingoloCampione.X - this.PrimoCampione.X))
              this.ObjGraficoX.AxisY.Min = (SingoloCampione.X - this.PrimoCampione.X)
            if (this.ObjGraficoX.AxisY.Max < (SingoloCampione.X - this.PrimoCampione.X))
              this.ObjGraficoX.AxisY.Max = (SingoloCampione.X - this.PrimoCampione.X)
            if (this.ObjGraficoY.AxisY.Min > (SingoloCampione.Y - this.PrimoCampione.Y)) 
              this.ObjGraficoY.AxisY.Min = (SingoloCampione.Y - this.PrimoCampione.Y)
            if (this.ObjGraficoY.AxisY.Max < (SingoloCampione.Y - this.PrimoCampione.Y))
              this.ObjGraficoY.AxisY.Max = (SingoloCampione.Y - this.PrimoCampione.Y)
            if (this.ObjGraficoZ.AxisY.Min > (SingoloCampione.Z - this.PrimoCampione.Z))
              this.ObjGraficoZ.AxisY.Min = (SingoloCampione.Z - this.PrimoCampione.Z)
            if (this.ObjGraficoZ.AxisY.Max < (SingoloCampione.Z - this.PrimoCampione.Z))
              this.ObjGraficoZ.AxisY.Max = (SingoloCampione.Z - this.PrimoCampione.Z)
          }
        })
      }

      this.ObjGraficoX.AxisY.Udm = TZMathFunct.GetMultiplo((this.ObjGraficoX.AxisY.Max - this.ObjGraficoX.AxisY.Min) / 5, 5, 'PiuVicino')
      this.ObjGraficoY.AxisY.Udm = TZMathFunct.GetMultiplo((this.ObjGraficoY.AxisY.Max - this.ObjGraficoY.AxisY.Min) / 5, 5, 'PiuVicino')
      this.ObjGraficoZ.AxisY.Udm = TZMathFunct.GetMultiplo((this.ObjGraficoZ.AxisY.Max - this.ObjGraficoZ.AxisY.Min) / 5, 5, 'PiuVicino')

      this.ObjGraficoX.AxisY.Min = this.ObjGraficoX.AxisY.Min - Math.abs(this.ObjGraficoX.AxisY.Udm * 0.05)
      this.ObjGraficoY.AxisY.Min = this.ObjGraficoY.AxisY.Min - Math.abs(this.ObjGraficoY.AxisY.Udm * 0.05)
      this.ObjGraficoZ.AxisY.Min = this.ObjGraficoZ.AxisY.Min - Math.abs(this.ObjGraficoZ.AxisY.Udm * 0.05)
      this.ObjGraficoX.AxisY.Max = this.ObjGraficoX.AxisY.Max + Math.abs(this.ObjGraficoX.AxisY.Udm * 0.05)
      this.ObjGraficoY.AxisY.Max = this.ObjGraficoY.AxisY.Max + Math.abs(this.ObjGraficoY.AxisY.Udm * 0.05)
      this.ObjGraficoZ.AxisY.Max = this.ObjGraficoZ.AxisY.Max + Math.abs(this.ObjGraficoZ.AxisY.Udm * 0.05)

      if (this.ObjGraficoX.AxisY.Udm == 0)
        this.ObjGraficoX.AxisY.Udm = 1
      if (this.ObjGraficoY.AxisY.Udm == 0)
        this.ObjGraficoY.AxisY.Udm = 1
      if (this.ObjGraficoZ.AxisY.Udm == 0)
        this.ObjGraficoZ.AxisY.Udm = 1

      this.RepaintDeep++
    },
     
    EsportaComePDF()
    {
      let Elemento = {}
      let MinData  = 0

      if (Array.isArray(this.Evento))
      {
        if (this.Evento.length > 0)
          MinData = this.Evento[0].DataEffettiva
        for (let i = 0; i < this.Evento.length; i++)
        {
          if (this.Evento[i].DataEffettiva < MinData)
          {
            Elemento = this.Evento[i].DataEffettiva
          }
        }
      }
      else
      {
        Elemento = this.Evento
      }
      this.$emit('EsportaPDFGrafico', Elemento)
      // è UN ARRAY NEL CASO DI EVENTI SOVRAPPOSTI
    },
    
    GetGraficiPDF()
    {
      // POTREBBE NON FUNZIONARE PER I SOVRAPPOSTI
      let DataEffettiva = ''
      let Modulo = -1
      let Millisecondi = 0
      
      let ModuloPDF = {}
  
      if (Array.isArray(this.Evento))
      {
        ModuloPDF.ListaModuli = structuredClone(this.Evento)
        if (this.Evento.length > 0)
        {
          DataEffettiva = this.Evento[0].DataEffettiva
          Millisecondi  = this.Evento[0].Millisecondi
        }
        for (let i = 0; i < this.Evento.length; i++)
        {
          if (this.Evento[i].DataEffettiva < DataEffettiva)
          {
            DataEffettiva = this.Evento[i].DataEffettiva
            Millisecondi  = this.Evento[i].Millisecondi 
          }
        }
        let LegendaSovrapposti = []
        for (let i = 0; i < this.Evento.length; i++)
        {
          let ObjLegenda = {}
          let IndexColore = i
          while (IndexColore >= COLORI_DEFAULT_GRAFICI.length)
          {
            IndexColore = IndexColore - COLORI_DEFAULT_GRAFICI.length
          }
          ObjLegenda.Colore = COLORI_DEFAULT_GRAFICI[IndexColore]
          ObjLegenda.Modulo = this.Evento[i].Modulo
          ObjLegenda.Data = this.Evento[i].DataEffettiva
          ObjLegenda.Millisecondi = this.Evento[i].Millisecondi
          LegendaSovrapposti.push(ObjLegenda)
        }
        ModuloPDF.LegendaSovrapposti = LegendaSovrapposti
        ModuloPDF.DataMin = DataEffettiva
      }
      else
      {
        ModuloPDF = structuredClone(this.Evento)
        DataEffettiva = this.Evento.DataEffettiva
        Millisecondi  = this.Evento.Millisecondi
        Modulo        = this.Evento.Modulo
      }
      ModuloPDF.ObjDatiGraficiX = this.ObjGraficoX.OggettoGrafico
      ModuloPDF.ObjDatiGraficiY = this.ObjGraficoY.OggettoGrafico
      ModuloPDF.ObjDatiGraficiZ = this.ObjGraficoZ.OggettoGrafico
      ModuloPDF.DataEffettiva = DataEffettiva
      ModuloPDF.Modulo = Modulo
      ModuloPDF.MinData = this.MinData
      ModuloPDF.MinDataMs = this.MinDataMs
      ModuloPDF.Millisecondi = Millisecondi

      // let ObjModulo = {Id : Modulo, Data: DataEffettiva, Profondita : this.Evento.Profondita, DatiGraficiX : ObjDatiGraficiX, DatiGraficiY : ObjDatiGraficiY, DatiGraficiZ : ObjDatiGraficiZ}

      // ModuloPDF.ModuliConsiderati.push(ObjModulo)

      if(!this.ObjPDF.PDFModulo)
        this.ObjPDF.PDFModulo = []

      if(!this.ObjPDF.PDFObjDatiGrafici)
        this.ObjPDF.PDFObjDatiGrafici = []

      this.ObjPDF.PDFModulo.push(ModuloPDF)
      this.ObjPDF.PDFObjDatiGrafici.push(structuredClone(this.ObjGrafico.OggettoGrafico))
    },

    EsportaExcel()
    {
      const wb = XLSX.utils.book_new();
      let ArrayContenitore = []
      let DataNomeFile = ''
      if (!this.EventiSovrapposti)
      {        
        let DataStart = Date.parse(this.Evento.DataEffettiva) + this.Evento.Millisecondi
        DataNomeFile = this.Evento.DataEffettiva
        let RigaIntestazione  = [
                                  {v: this.GetTraduzioneLabel('Generic','TKN_MOD_NR',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}},
                                  {v: this.Evento.Modulo, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}},
                                  {v: this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}},
                                  {v: this.Evento.Profondita, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}},
                                  // {v: this.GetTraduzioneLabel('Generic','TKN_DATA',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}},
                                  // {v: this.Evento.DataEffettiva, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}},
                                ]
        ArrayContenitore.push(RigaIntestazione)
        let Row = 
        [
          { v: this.GetTraduzioneLabel('Generic','TKN_DATA',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
          { v: this.GetTraduzioneLabel('Generic','TKN_ASSE_X',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
          { v: this.GetTraduzioneLabel('Generic','TKN_ASSE_Y',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
          { v: this.GetTraduzioneLabel('Generic','TKN_ASSE_Z',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
        ];
        ArrayContenitore.push(Row)

        // for (let i = 0; i < this.Evento.Campioni.length; i++)
        // {
        //   let Elemento = this.Evento.Campioni[i]
        //   let RowElemento = 
        //   [
        //     { v: TZDateFunct.FormatDateTime("dd/mm/yyyy hh:nn:ss:lll", Date(DataStart)), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
        //     { v: (Elemento.X).toFixed(1), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
        //     { v: (Elemento.Y).toFixed(1), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
        //     { v: (Elemento.Z).toFixed(1), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
        //   ];
        //   ArrayContenitore.push(RowElemento)
        //   DataStart += this.Evento.PeriodoCampionamento
        // }

        this.Evento.Campioni.forEach((elemento) =>
        {
          let RowElemento = 
          [
            { v: TZDateFunct.FormatDateTime("dd/mm/yyyy hh:nn:ss:lll", new Date(DataStart)), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'center' },}},
            { v: (elemento.X).toFixed(1), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
            { v: (elemento.Y).toFixed(1), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
            { v: (elemento.Z).toFixed(1), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
          ];
          ArrayContenitore.push(RowElemento)
          DataStart += this.Evento.PeriodoCampionamento
        })
      }
      else
      {
        this.Evento.forEach((SingleEvento) =>
        {
          if (DataNomeFile != '')
            DataNomeFile += '_'
          DataNomeFile += SingleEvento.DataEffettiva
          let DataStart = Date.parse(SingleEvento.DataEffettiva) + SingleEvento.Millisecondi

          let RigaIntestazione  = [
                                    {v: this.GetTraduzioneLabel('Generic','TKN_MOD_NR',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}},
                                    {v: SingleEvento.Modulo, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}},
                                    {v: this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}},
                                    {v: SingleEvento.Profondita, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}},
                                    // {v: this.GetTraduzioneLabel('Generic','TKN_DATA',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}},
                                    // {v: SingleEvento.DataEffettiva, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}},
                                  ]
          ArrayContenitore.push(RigaIntestazione)
          let Row = 
          [
            { v: this.GetTraduzioneLabel('Generic','TKN_DATA',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
            { v: this.GetTraduzioneLabel('Generic','TKN_ASSE_X',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
            { v: this.GetTraduzioneLabel('Generic','TKN_ASSE_Y',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
            { v: this.GetTraduzioneLabel('Generic','TKN_ASSE_Z',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
          ];
          ArrayContenitore.push(Row)

          SingleEvento.Campioni.forEach(function(elemento)
          {
            let RowElemento = 
            [
              { v: TZDateFunct.FormatDateTime("dd/mm/yyyy hh:nn:ss:lll", new Date(DataStart)), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'center' },}},
              { v: (elemento.X).toFixed(1), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
              { v: (elemento.Y).toFixed(1), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
              { v: (elemento.Z).toFixed(1), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
            ];
            ArrayContenitore.push(RowElemento)
            DataStart += SingleEvento.PeriodoCampionamento
          })
          ArrayContenitore.push([])
        })
      }
      const ws = XLSX.utils.aoa_to_sheet(ArrayContenitore);
      XLSX.utils.book_append_sheet(wb, ws, 'Dati');

      var wscols  = [
                      {wch:20},
                      {wch:20},
                      {wch:20},
                      {wch:20},
                      {wch:20},
                      {wch:30},
                    ];
                    
      ws['!cols'] = wscols;

      XLSX.writeFile(wb, 'ListaEvSinteticiAccel_' + DataNomeFile + ".xlsx");
    },

    ApriPopupImpostazioniAssi(Asse)
    {
      this.ObjPopupImpostazioniAssi.TipoAsse   = Asse
      let AxisPopup                            = {}
      AxisPopup.Max                            = 0
      AxisPopup.Min                            = 0
      AxisPopup.Udm                            = 0
      switch (Asse)
      {
        case this.TipiAssi.X :
        {
          AxisPopup.Max = this.ObjGraficoX.AxisY.Max
          AxisPopup.Min = this.ObjGraficoX.AxisY.Min
          AxisPopup.Udm = this.ObjGraficoX.AxisY.Udm
          break
        }
        case this.TipiAssi.Y :
        {
          AxisPopup.Max = this.ObjGraficoY.AxisY.Max
          AxisPopup.Min = this.ObjGraficoY.AxisY.Min
          AxisPopup.Udm = this.ObjGraficoY.AxisY.Udm
          break
        }
        case this.TipiAssi.Z :
        {
          AxisPopup.Max = this.ObjGraficoZ.AxisY.Max
          AxisPopup.Min = this.ObjGraficoZ.AxisY.Min
          AxisPopup.Udm = this.ObjGraficoZ.AxisY.Udm
          break
        }
        case this.TipiAssi.Tutte :
        {
          AxisPopup.Max = 5
          AxisPopup.Min = -5
          AxisPopup.Udm = 2
          break
        }
      }
      this.ObjPopupImpostazioniAssi.Axis = AxisPopup
      this.PopupImpostazioniAssi = true
    },

    ConfermaPopupAssi()
    {
      switch (this.ObjPopupImpostazioniAssi.TipoAsse)
      {
        case this.TipiAssi.X :
        {
          this.ObjGraficoX.AxisY.Max = this.ObjPopupImpostazioniAssi.Axis.Max
          this.ObjGraficoX.AxisY.Min = this.ObjPopupImpostazioniAssi.Axis.Min 
          this.ObjGraficoX.AxisY.Udm = this.ObjPopupImpostazioniAssi.Axis.Udm
          break
        }
        case this.TipiAssi.Y :
        {
          this.ObjGraficoY.AxisY.Max = this.ObjPopupImpostazioniAssi.Axis.Max
          this.ObjGraficoY.AxisY.Min = this.ObjPopupImpostazioniAssi.Axis.Min
          this.ObjGraficoY.AxisY.Udm = this.ObjPopupImpostazioniAssi.Axis.Udm
          break
        }
        case this.TipiAssi.Z :
        {
          this.ObjGraficoZ.AxisY.Max = this.ObjPopupImpostazioniAssi.Axis.Max
          this.ObjGraficoZ.AxisY.Min = this.ObjPopupImpostazioniAssi.Axis.Min
          this.ObjGraficoZ.AxisY.Udm = this.ObjPopupImpostazioniAssi.Axis.Udm
          break
        }
        case this.TipiAssi.Tutte :
        { 
          this.ObjGraficoX.AxisY.Max = this.ObjPopupImpostazioniAssi.Axis.Max
          this.ObjGraficoX.AxisY.Min = this.ObjPopupImpostazioniAssi.Axis.Min 
          this.ObjGraficoX.AxisY.Udm = this.ObjPopupImpostazioniAssi.Axis.Udm
          this.ObjGraficoY.AxisY.Max = this.ObjPopupImpostazioniAssi.Axis.Max
          this.ObjGraficoY.AxisY.Min = this.ObjPopupImpostazioniAssi.Axis.Min
          this.ObjGraficoY.AxisY.Udm = this.ObjPopupImpostazioniAssi.Axis.Udm
          this.ObjGraficoZ.AxisY.Max = this.ObjPopupImpostazioniAssi.Axis.Max
          this.ObjGraficoZ.AxisY.Min = this.ObjPopupImpostazioniAssi.Axis.Min
          this.ObjGraficoZ.AxisY.Udm = this.ObjPopupImpostazioniAssi.Axis.Udm          
          break
        }
      }
      this.Repaint++
      this.PopupImpostazioniAssi = false
    },

    AnnullaPopupAssi()
    {
      this.PopupImpostazioniAssi = false
    },

    FormattaData(DataDaFormattare, Millisecondi)
    { 
      let [Data, Orario] = DataDaFormattare.split(' ')
      let [Anno, Mese, Giorno] = Data.split('-')
      
      let DataFormattata = `${Giorno.padStart(2, '0')}/${Mese.padStart(2, '0')}/${Anno} ${Orario}.${Millisecondi}`
      return DataFormattata
    },

    GetDivisore(MaxX)
    {
      let Divisore = 0
      if (MaxX <= SOGLIA_UDM_MS)
        Divisore = 50
      else
      {
        if (MaxX <= SOGLIA_UDM_MINUTI)
          Divisore = 60000
        else
          Divisore = 60000 * 60
      }
      return Divisore
    },    

    GetStartConfig()
    {
      let AssiStart = {}
      AssiStart.X = {}
      AssiStart.Y = {}
      AssiStart.X.Min = 0
      // if (!this.EventiSovrapposti)
      //   AssiStart.X.Max = this.Evento.PeriodoCampionamento * this.Evento.Campioni.length
      // else
      // {
      //   for (let i = 0; i < this.Evento.length; i++)
      //   {
      //     let SingleEvento = this.Evento[i]
      //     if (AssiStart.X.Max < SingleEvento.PeriodoCampionamento * SingleEvento.Campioni.length)
      //       AssiStart.X.Max = SingleEvento.PeriodoCampionamento * SingleEvento.Campioni.length
      //   }
      // }
      let DataMaggiore = new Date(this.DataPartenza).valueOf()
      DataMaggiore = Math.max(this.UltimaData, 
                              (new Date(this.DataPartenza).valueOf() + this.Stacking)) 
      AssiStart.X.Max = DataMaggiore - new Date(this.DataPartenza).valueOf()
      if (AssiStart.X.Max == AssiStart.X.Min)
        AssiStart.X.Max = 10
      AssiStart.Y.Min = 0
      AssiStart.Y.Max = 10
      AssiStart.Y.Udm = 1

      let Divisore = this.GetDivisore(AssiStart.X.Max)
      AssiStart.X.Udm = TZMathFunct.GetMultiplo(AssiStart.X.Max / 10, Divisore, 'PiuVicino')
      AssiStart.X.Max = TZMathFunct.GetMultiplo(AssiStart.X.Max, Divisore, 'Eccesso')

      if (AssiStart.X.Udm == 0)
        AssiStart.X.Udm = 1
          
      let AxisPopup                            = {}
      AxisPopup.Max                            = 0
      AxisPopup.Min                            = 0
      AxisPopup.Udm                            = 0
      this.ObjGrafico.AxisPopup                = AxisPopup
      this.ObjPopupImpostazioniAssi.Axis       = TZGenericFunct.GetCopyOfObject(AxisPopup)
      this.ObjPopupImpostazioniAssi.TipoAsse   = TIPI_ASSI.Tutte

      this.ObjGraficoX.AxisX    = {}
      this.ObjGraficoX.AxisY    = {}
      this.ObjGraficoX.Generale = {}

      this.ObjGraficoY.AxisX    = {}
      this.ObjGraficoY.AxisY    = {}
      this.ObjGraficoY.Generale = {}

      this.ObjGraficoZ.AxisX    = {}
      this.ObjGraficoZ.AxisY    = {}
      this.ObjGraficoZ.Generale = {}

      this.ObjGraficoX.AxisY.Min = AssiStart.Y.Min
      this.ObjGraficoX.AxisY.Max = AssiStart.Y.Max
      this.ObjGraficoX.AxisY.Udm = AssiStart.Y.Udm
      this.ObjGraficoX.AxisX.Min = AssiStart.X.Min
      this.ObjGraficoX.AxisX.Max = AssiStart.X.Max
      this.ObjGraficoX.AxisX.Udm = AssiStart.X.Udm

      this.ObjGraficoY.AxisY.Min = AssiStart.Y.Min
      this.ObjGraficoY.AxisY.Max = AssiStart.Y.Max
      this.ObjGraficoY.AxisY.Udm = AssiStart.Y.Udm
      this.ObjGraficoY.AxisX.Min = AssiStart.X.Min
      this.ObjGraficoY.AxisX.Max = AssiStart.X.Max
      this.ObjGraficoY.AxisX.Udm = AssiStart.X.Udm

      this.ObjGraficoZ.AxisY.Min = AssiStart.Y.Min
      this.ObjGraficoZ.AxisY.Max = AssiStart.Y.Max
      this.ObjGraficoZ.AxisY.Udm = AssiStart.Y.Udm
      this.ObjGraficoZ.AxisX.Min = AssiStart.X.Min
      this.ObjGraficoZ.AxisX.Max = AssiStart.X.Max
      this.ObjGraficoZ.AxisX.Udm = AssiStart.X.Udm

      if (!this.EventiSovrapposti)
      {
        this.ObjGraficoX.Generale = {Campioni : [], PeriodoCampionamento : this.Evento.PeriodoCampionamento, DataEffettiva : this.Evento.DataEffettiva, Millisecondi : this.Evento.Millisecondi}
        this.ObjGraficoY.Generale = {Campioni : [], PeriodoCampionamento : this.Evento.PeriodoCampionamento, DataEffettiva : this.Evento.DataEffettiva, Millisecondi : this.Evento.Millisecondi}
        this.ObjGraficoZ.Generale = {Campioni : [], PeriodoCampionamento : this.Evento.PeriodoCampionamento, DataEffettiva : this.Evento.DataEffettiva, Millisecondi : this.Evento.Millisecondi}
        // this.ObjGraficoZ.Generale.Campioni = []
        // this.ObjGraficoZ.Generale.PeriodoCampionamento = this.Evento.PeriodoCampionamento
        // this.ObjGraficoY.Generale.Campioni = []
        // this.ObjGraficoY.Generale.PeriodoCampionamento = this.Evento.PeriodoCampionamento
        // this.ObjGraficoX.Generale.Campioni = []    
        // this.ObjGraficoX.Generale.PeriodoCampionamento = this.Evento.PeriodoCampionamento
      }
      else
      {
        this.ObjGraficoX.Eventi = []
        this.ObjGraficoY.Eventi = []
        this.ObjGraficoZ.Eventi = []
        for (let i = 0; i < this.Evento.length; i++)
        {
          let SingleEvento = this.Evento[i]
          let ObjEventoX = {Campioni : [], PeriodoCampionamento : SingleEvento.PeriodoCampionamento, DataEffettiva : SingleEvento.DataEffettiva, Millisecondi : SingleEvento.Millisecondi}
          let ObjEventoY = {Campioni : [], PeriodoCampionamento : SingleEvento.PeriodoCampionamento, DataEffettiva : SingleEvento.DataEffettiva, Millisecondi : SingleEvento.Millisecondi}
          let ObjEventoZ = {Campioni : [], PeriodoCampionamento : SingleEvento.PeriodoCampionamento, DataEffettiva : SingleEvento.DataEffettiva, Millisecondi : SingleEvento.Millisecondi}
          this.ObjGraficoX.Eventi.push(ObjEventoX)
          this.ObjGraficoY.Eventi.push(ObjEventoY)
          this.ObjGraficoZ.Eventi.push(ObjEventoZ)
        }
      }
    }
  },
  
  computed:
  {
    ObjPDF :
    {
      get()
      {
        return this.ParametriPDF
      }
    },

    GraphX :
    {
      get()
      {
        return this.GraphProps.GraphX
      }
    },

    GraphY :
    {
      get()
      {
        return this.GraphProps.GraphY
      }
    },

    GraphZ :
    {
      get()
      {
        return this.GraphProps.GraphZ
      }
    },
  },
  
  watch:
  {
    GraficiChangeAllSupSoglie:
    {
      handler()
      {
        if (this.GraphProps.GraphX.Updated)
        {
          this.ObjGraficoX.AxisY.Min = this.GraphX.Min
          this.ObjGraficoX.AxisY.Max = this.GraphX.Max
          this.ObjGraficoX.AxisY.Udm = this.GraphX.Udm
        }
        if (this.GraphProps.GraphY.Updated)
        {
          this.ObjGraficoY.AxisY.Min = this.GraphY.Min
          this.ObjGraficoY.AxisY.Max = this.GraphY.Max
          this.ObjGraficoY.AxisY.Udm = this.GraphY.Udm
        }
        if (this.GraphProps.GraphZ.Updated)
        {
          this.ObjGraficoZ.AxisY.Min = this.GraphZ.Min
          this.ObjGraficoZ.AxisY.Max = this.GraphZ.Max
          this.ObjGraficoZ.AxisY.Udm = this.GraphZ.Udm
        }
        this.RepaintDeep++
      }      
    },

    GraficiChange:
    {
      handler()
      {
        for (let i = 0; i < this.ListaRighelli.length; i++)
        {
          let Color         = this.ListaRighelli[i].Colore
          let DistanceFromY = this.ListaRighelli[i].Millisecondi
          let RighelloX     = this.ObjGraficoX.OggettoGrafico.AddRighello()
          let RighelloY     = this.ObjGraficoY.OggettoGrafico.AddRighello()
          let RighelloZ     = this.ObjGraficoZ.OggettoGrafico.AddRighello()

          RighelloX.Color         = Color
          RighelloX.DistanceFromY = DistanceFromY
          RighelloY.Color         = Color
          RighelloY.DistanceFromY = DistanceFromY
          RighelloZ.Color         = Color
          RighelloZ.DistanceFromY = DistanceFromY
        }
        this.RepaintDeep++
      }
    },

    GraficiAdatta:
    {
      handler()
      {
        this.AdattaAll()
      }
    },

    Relativo:
    {
      handler()
      {
        this.ChangeRelativo()
      }
    },

    GetDatiPDF :
    {
      handler(NewValue)
      {
        if (NewValue != 0)
          this.GetGraficiPDF()
      }
    },
  },

  beforeMount()
  {
    this.GetStartConfig()
    this.ChangeRelativo()
    if (!this.EventiSovrapposti)
    {
      this.TitoloFrame = this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_SUP_DEL',this.LinguaUtente) + ' ' + this.FormattaData(this.Evento.DataEffettiva, this.Evento.Millisecondi) + ' ' + this.GetTraduzioneLabel('Generic','TKN_MOD_NR',this.LinguaUtente) + ' ' + this.Evento.Modulo + ' - ' + this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente) + ': ' + this.Evento.Profondita.toFixed(2) + ' ' + this.GetTraduzioneLabel('UdmGenerali','TKN_MPC',this.LinguaUtente)
    }
    else
    {
      if (this.Evento.length == 1)
      {
        this.TitoloFrame = this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_SUP_DEL',this.LinguaUtente) + ' ' + this.FormattaData(this.Evento[0].DataEffettiva, this.Evento[0].Millisecondi) + ' ' + this.GetTraduzioneLabel('Generic','TKN_MOD_NR',this.LinguaUtente) +' ' + this.Evento[0].Modulo + ' - ' + this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente) + ': ' + this.Evento[0].Profondita.toFixed(2) + ' ' + this.GetTraduzioneLabel('UdmGenerali','TKN_MPC',this.LinguaUtente)
      }
      else
      {
        let MinProfondita = 9999
        let MaxProfondita = -9999
        this.Evento.forEach((element) => 
        {
          MinProfondita = Math.min(MinProfondita, element.Profondita)
          MaxProfondita = Math.max(MaxProfondita, element.Profondita)
        })
        this.TitoloFrame = this.GetTraduzioneLabel('VUEFrameComponenteGraficoAccSupSoglie','TKN_FRM_GRAF_ACC_SUP_S_SUP_SOVR',this.LinguaUtente) + ' - ' + this.GetTraduzioneLabel('Generic','TKN_PROFONDITA_DA',this.LinguaUtente) + ' ' + MinProfondita.toFixed(2) + ' ' + this.GetTraduzioneLabel('Generic','TKN_LETT_A',this.LinguaUtente) + ' ' + MaxProfondita.toFixed(2) + ' ' + this.GetTraduzioneLabel('UdmGenerali','TKN_MPC',this.LinguaUtente)
      }
    }
  },
  mounted()
  {
    this.CalcolaGrandezzaDivCanvas()
    window.addEventListener('resize', this.CalcolaGrandezzaDivCanvas)
  },
  beforeUnmount()
  {
    window.removeEventListener('resize', this.CalcolaGrandezzaDivCanvas)
  }
}
</script>